import { compose } from "redux";
import { connect } from "react-redux";

import mapStateToProps from "./structured-selectors";

const withConnect = connect(mapStateToProps);

export const enhance = compose(withConnect);
